import { render } from "./OapBeforeAfter.vue?vue&type=template&id=370b45c6"
import script from "./OapBeforeAfter.vue?vue&type=script&lang=js"
export * from "./OapBeforeAfter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__